"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hydrationHelpers_1 = require("../hydrationHelpers");
var QuoteLineItemWidget_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteLineItem/QuoteLineItemWidget");
var QuoteLineItemPublicProvider_1 = require("./QuoteLineItemPublicProvider");
var QuoteLineItem = function (_a) {
    var attributes = _a.attributes, children = _a.children, lineItem = _a.lineItem, id = _a.id, price = _a.price, di = _a.di;
    return (react_1.default.createElement(QuoteLineItemPublicProvider_1.QuoteLineItemPublicProvider, { item: lineItem, id: id, price: price, di: di },
        react_1.default.createElement(QuoteLineItemWidget_1.QuoteLineItemWidget, { attributes: attributes },
            react_1.default.createElement(hydrationHelpers_1.ContentArea, null, children))));
};
exports.default = (0, hydrationHelpers_1.withHydrationHost)(QuoteLineItem, { componentName: "QuoteLineItem", ignoreProps: ["children"] });
